import { useLocation } from 'react-router-dom';
import { routes } from '../../Routes/routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faBell } from '@fortawesome/free-solid-svg-icons';

/**
 * Presentational top bar. Derives the page title from the active route's
 * existing `name`. No data fetching, no business logic — chrome only.
 */
export default function Topbar() {
    const location = useLocation();
    const segments = location.pathname.split("/").filter(Boolean);
    const last = segments[segments.length - 1] || "dashboard";

    const match = routes.find((r) => r.route === last && r.name);
    const title = match?.name || "Dashboard";

    return (
        <div className="ds-topbar tw-flex tw-items-center tw-gap-4 tw-px-6">
            <div className="tw-min-w-0">
                <div className="ds-eyebrow">NIXBNK</div>
                <div className="ds-page-title" style={{ fontSize: 18 }}>{title}</div>
            </div>

            {/* <div className="ds-topbar__search tw-ml-auto">
                <FontAwesomeIcon icon={faMagnifyingGlass} className="ds-topbar__search-icon" />
                <input type="text" placeholder="Search…" aria-label="Search" />
            </div> */}

            {/* <button type="button" className="ds-topbar__icon-btn" aria-label="Notifications">
                <FontAwesomeIcon icon={faBell} />
            </button> */}

            {/* <div className="ds-topbar__profile">
                <div className="ds-topbar__avatar" aria-hidden>NX</div>
                <div className="ds-topbar__profile-meta">
                    <span className="ds-topbar__profile-name">NIXBNK</span>
                    <span className="ds-topbar__profile-role">Admin</span>
                </div>
            </div> */}
        </div>
    );
}
